import React from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import { format } from 'date-fns';

const AuditLogDetailsModal = ({ log, onClose }) => {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="p-4 card-container rounded-lg max-w-3xl w-full max-h-[80vh] overflow-y-auto scrollable flex flex-col gap-4">
                {/* Header */}
                <div className="flex items-center justify-between">
                    <h3 className="text-lg font-semibold text-font-primary">
                        Audit Log Details
                    </h3>
                    <button
                        onClick={onClose}
                        className="text-font-secondary hover:text-font-primary transition-colors"
                    >
                        <Icon icon="mdi:close" className="text-2xl" />
                    </button>
                </div>

                <hr className="border-border" />

                {/* Content */}
                <div className="flex flex-col gap-4">
                    {/* Basic Info */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="text-sm font-semibold text-font-secondary">Log ID</label>
                            <div className="text-sm text-font-primary mt-1 font-mono bg-bgAccent px-2 py-1 rounded break-all">
                                {log.id}
                            </div>
                        </div>
                        <div>
                            <label className="text-sm font-semibold text-font-secondary">Timestamp</label>
                            <div className="text-sm text-font-primary mt-1">
                                {format(new Date(log.timestamp), 'PPpp')}
                            </div>
                        </div>
                    </div>

                    {/* Action Info */}
                    <div>
                        <label className="text-sm font-semibold text-font-secondary">Action Type</label>
                        <div className="text-base text-font-primary mt-1 font-semibold">
                            {log.action_type.replace(/_/g, ' ')}
                        </div>
                    </div>

                    {/* Admin Info */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="text-sm font-semibold text-font-secondary">Admin Name</label>
                            <div className="text-sm text-font-primary mt-1">
                                {log.admin_name || 'N/A'}
                            </div>
                        </div>
                        <div>
                            <label className="text-sm font-semibold text-font-secondary">Admin Email</label>
                            <div className="text-sm text-font-primary mt-1 break-all">
                                {log.admin_email || 'N/A'}
                            </div>
                        </div>
                    </div>

                    {/* Technical Info */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="text-sm font-semibold text-font-secondary">IP Address</label>
                            <div className="text-sm text-font-primary mt-1 font-mono">
                                {log.ip_address || 'N/A'}
                            </div>
                        </div>
                        <div>
                            <label className="text-sm font-semibold text-font-secondary">Request ID</label>
                            <div className="text-sm text-font-primary mt-1 font-mono break-all">
                                {log.request_id || 'N/A'}
                            </div>
                        </div>
                    </div>

                    {/* User Agent */}
                    {log.user_agent && (
                        <div>
                            <label className="text-sm font-semibold text-font-secondary">User Agent</label>
                            <div className="text-sm text-font-primary mt-1 font-mono bg-bgAccent px-2 py-1 rounded break-all">
                                {log.user_agent}
                            </div>
                        </div>
                    )}

                    {/* Details Object */}
                    <div>
                        <label className="text-sm font-semibold text-font-secondary">Action Details</label>
                        <pre className="text-xs text-font-primary mt-1 bg-bgAccent px-3 py-2 rounded overflow-x-auto">
                            {JSON.stringify(log.details, null, 2)}
                        </pre>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AuditLogDetailsModal;

